import React from 'react'
import { Link } from 'react-router-dom'
import propTypes from 'prop-types'

function Button(props) {
  const className = [props.className]
  if (props.isPrimary) className.push('btn-primary')
  if (props.isDisabled) className.push('disabled')
  if (props.isLarge) className.push('btn-lg')
  if (props.isSmall) className.push('btn-sm')
  if (props.isBlock) className.push('btn-block')
  if (props.hasShadow) className.push('btn-shadow')
  if (props.isBtn) className.push('btn')
  if (props.variant) className.push(`btn-${props.variant}`)

  const onClick = () => {
    if (props.onClick) props.onClick()
  }
  if (props.isDisabled || props.isLoading) {
    if (props.isDisabled) className.push('disabled')
    return (
      <span
        className={`btn disabled ${className.join(' ')}`}
        title={props.title}
        style={props.style}
      >
        {props.isLoading ? (
          <>
            <span className='spinner-border spinner-border-sm'></span>
            <span className='sr-only'>Loading....</span>
          </>
        ) : (
          props.children
        )}
      </span>
    )
  }

  if (props.type === 'link') {
    if (props.isExternal) {
      return (
        <a
          title={props.title}
          href={props.href}
          className={className.join(' ')}
          style={props.style}
          target={props.target === '_blank' ? '_blank' : undefined}
          rel={props.target === 'blank' ? 'noopener noreferer' : undefined}
        >
          {props.children}
        </a>
      )
    } else {
      return (
        <Link
          to={props.href}
          className={className.join(' ')}
          style={props.style}
          onClick={onClick}
          title={props.title}
        >
          {props.children}
        </Link>
      )
    }
  }

  return (
    <button
      type={!props.type ? 'button' : props.type}
      className={`btn ${className.join(' ')}`}
      title={props.title}
      style={props.style}
      onClick={onClick}
    >
      {props.children}
    </button>
  )
}

export default Button

Button.propTypes = {
  type: propTypes.oneOf(['button', 'link', 'submit', 'reset']),
  onClick: propTypes.func,
  target: propTypes.string,
  className: propTypes.string,
  variant: propTypes.string,
  isPrimary: propTypes.bool,
  isDisabled: propTypes.bool,
  isLoading: propTypes.bool,
  isLarge: propTypes.bool,
  isSmall: propTypes.bool,
  isExternal: propTypes.bool,
  hasShadow: propTypes.bool,
}
